// sticky header
$(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
        $(".header").addClass("__scrolled");
    } else {
        $(".header").removeClass("__scrolled");
    }
});